import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useSnackbar } from "notistack";
import { contactUs } from "../shared/_services/common.services";
import { useAuth } from "../context/AuthContext.jsx";
import StarsIcon from "../styles/StarsIcon";
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
  Input,
  Textarea,
} from "./ui";

const ContactUsModal = ({ onClose }) => {
  const { enqueueSnackbar } = useSnackbar();
  const { role } = useAuth();

  const initialValues = {
    subject: "",
    message: "",
  };

  const validationSchema = Yup.object().shape({
    subject: Yup.string().required("Subject is required"),
    message: Yup.string().required("Message is required"),
  });

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    const user = JSON.parse(localStorage.getItem("currentUser"));
    const email = user?.user?.email;
    const userType = user?.user?.userType;
    const { subject, message } = values;
    try {
      await contactUs(email, subject, message,userType);
      enqueueSnackbar("Message sent successfully", { variant: "success" });
      resetForm();
      onClose();
    } catch (error) {
      enqueueSnackbar("Failed to send message", { variant: "error" });
    }
    setSubmitting(false);
  };

  return (
    <Dialog
      open
      surface={role === "client" ? "dark" : "light"}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
    >
      <DialogContent
        onInteractOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ errors, touched, isSubmitting }) => (
            <Form>
              <div className="tw-flex tw-items-start tw-justify-between tw-gap-4">
                <DialogTitle>Let’s get in touch</DialogTitle>
                <Button
                  variant="icon"
                  size="sm"
                  iconOnly
                  aria-label="Close"
                  className="tw-shrink-0"
                  onClick={onClose}
                >
                  <StarsIcon name="x" className="tw-h-4 tw-w-4 tw-shrink-0" />
                </Button>
              </div>
              <DialogDescription className="tw-mb-4">
                We would love to connect and learn more about you.
              </DialogDescription>
              <div className="tw-mb-4">
                <Field
                  as={Input}
                  type="text"
                  id="subject"
                  name="subject"
                  placeholder="Subject"
                  aria-label="Subject"
                  invalid={Boolean(errors.subject && touched.subject)}
                />
                <ErrorMessage
                  name="subject"
                  component="p"
                  className="tw-mb-0 tw-mt-2 tw-text-sm tw-text-danger"
                />
              </div>
              <div className="tw-mb-4">
                <Field
                  as={Textarea}
                  id="message"
                  name="message"
                  placeholder="Let us know how we can help"
                  aria-label="Message"
                  invalid={Boolean(errors.message && touched.message)}
                  rows="3"
                />
                <ErrorMessage
                  name="message"
                  component="p"
                  className="tw-mb-0 tw-mt-2 tw-text-sm tw-text-danger"
                />
              </div>
              <div className="tw-mt-6 tw-text-center">
                <Button type="submit" disabled={isSubmitting}>
                  Send
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  );
};

export default ContactUsModal;
